<main class="eb-page">
  <!-- En-tête de la page -->
  <section class="eb-hero">
    <div class="container">
      <h1>{{ 'pages.etudes-bibliques.etudes-bibliques.text001' | translate }}</h1>
      <p class="subtitle">{{ 'pages.etudes-bibliques.etudes-bibliques.text002' | translate }}</p>
    </div>
  </section>

  <!-- Section Introduction & Objectifs -->
  <section class="eb-intro-section">
    <div class="container">
      <div class="intro-card">
        <p>
          {{ 'pages.etudes-bibliques.etudes-bibliques.text003' | translate }}
        </p>
        <ul class="styled-list">
          <li><span>✦</span> {{ 'pages.etudes-bibliques.etudes-bibliques.text004' | translate }}</li>
          <li><span>✦</span> {{ 'pages.etudes-bibliques.etudes-bibliques.text005' | translate }}</li>
          <li><span>✦</span> {{ 'pages.etudes-bibliques.etudes-bibliques.text006' | translate }}</li>
          <li><span>✦</span> {{ 'pages.etudes-bibliques.etudes-bibliques.text007' | translate }}</li>
          <li><span>✦</span> {{ 'pages.etudes-bibliques.etudes-bibliques.text008' | translate }}</li>
          <li><span>✦</span> {{ 'pages.etudes-bibliques.etudes-bibliques.text009' | translate }}</li>
        </ul>
        <p class="intro-quote">
          {{ 'pages.etudes-bibliques.etudes-bibliques.text010' | translate }}
        </p>
      </div>
    </div>
  </section>

  <!-- SECTION 1 : CARTE INTERACTIVE -->
  <section class="eb-map-section" id="carte">
    <div class="container">
      <h2 class="section-title">{{ 'pages.etudes-bibliques.etudes-bibliques.text011' | translate }}</h2>
      <p class="section-desc">{{ 'pages.etudes-bibliques.etudes-bibliques.text012' | translate }}</p>
      
      <div class="map-wrapper">
        <!-- Div obligatoire pour Leaflet -->
        <div id="map" class="interactive-map"></div>
        
        <!-- Légende -->
<!-- Légende mise à jour avec l'icône exacte -->
        <div class="map-legend">
          <h4>{{ 'pages.etudes-bibliques.etudes-bibliques.text013' | translate }}</h4>
          <div class="legend-item">
            <img src="https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png" alt="Marqueur" class="legend-pin-img">
            <span>{{ 'pages.etudes-bibliques.etudes-bibliques.text014' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- SECTION 2 : HORAIRES ET GROUPES ACTUELS -->
  <section class="eb-horaires-section" id="horaires">
    <div class="container">
      <h2 class="section-title">{{ 'pages.etudes-bibliques.etudes-bibliques.text015' | translate }}</h2>
      
      <div class="groups-grid">
        @for (antenne of antennes; track antenne.name) {
          <div class="group-card">
            <div class="group-header">
              <h3>{{ antenne.name }}</h3>
              <span class="badge">{{ antenne.type | translate }}</span>
            </div>
            <div class="group-body">
              <p class="resp"><strong>{{ 'pages.etudes-bibliques.etudes-bibliques.text016' | translate }}</strong> {{ antenne.resp | translate }}</p>
              <p class="time"><strong>{{ 'pages.etudes-bibliques.etudes-bibliques.text017' | translate }}</strong> {{ antenne.horaires | translate }}</p>
            </div>
          </div>
        }
      </div>

      <!-- Futures antennes -->
      <div class="future-antennes-box">
        <h3>{{ 'pages.etudes-bibliques.etudes-bibliques.text018' | translate }}</h3>
        <p>{{ 'pages.etudes-bibliques.etudes-bibliques.text019' | translate }} <strong>Lyon, Rennes et Metz</strong>.</p>
      </div>
    </div>
  </section>

  <!-- SECTION 3 : FORMULAIRE D'INSCRIPTION -->
  <section class="eb-form-section" id="inscription">
    <div class="container">
      <h2 class="section-title">{{ 'pages.etudes-bibliques.etudes-bibliques.text020' | translate }}</h2>
      <p class="section-desc">{{ 'pages.etudes-bibliques.etudes-bibliques.text021' | translate }}</p>

      <div class="form-card">
        <form #inscriptionForm="ngForm"
          (ngSubmit)="onSubmit(inscriptionForm)"
          novalidate>
          <div class="website-field" aria-hidden="true">
            <label for="website">Site internet</label>
            <input
              id="website"
              type="text"
              name="website"
              tabindex="-1"
              autocomplete="off">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="nom">{{ 'pages.etudes-bibliques.etudes-bibliques.text022' | translate }}</label>
              <input type="text" id="nom" [(ngModel)]="formData.nom" name="nom" required [placeholder]="'pages.etudes-bibliques.etudes-bibliques.placeholder028' | translate">
            </div>
            <div class="form-group">
              <label for="email">{{ 'pages.etudes-bibliques.etudes-bibliques.text023' | translate }}</label>
              <input type="email" id="email" [(ngModel)]="formData.email" name="email" required placeholder="votre.email@exemple.com">
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="telephone">{{ 'pages.etudes-bibliques.etudes-bibliques.text024' | translate }}</label>
              <input type="tel" id="telephone" [(ngModel)]="formData.telephone" name="telephone" placeholder="06 00 00 00 00">
            </div>
            <div class="form-group">
              <label for="antenne">{{ 'pages.etudes-bibliques.etudes-bibliques.text025' | translate }}</label>
              <select id="antenne" [(ngModel)]="formData.antenne" name="antenne" required>
                @for (antenne of antennes; track antenne.name) {
                  <option [value]="antenne.name">{{ antenne.name }}</option>
                }
              </select>
            </div>
          </div>

          <div class="form-group full-width">
            <label for="message">{{ 'pages.etudes-bibliques.etudes-bibliques.text026' | translate }}</label>
            <textarea id="message" [(ngModel)]="formData.message" name="message" rows="4" [placeholder]="'pages.etudes-bibliques.etudes-bibliques.placeholder029' | translate"></textarea>
          </div>

          @if (successMessage()) {
            <div class="form-feedback form-feedback--success"
                role="status"
                aria-live="polite">
              <span class="feedback-icon" aria-hidden="true">✓</span>

              <div>
                <strong>Inscription envoyée</strong>
                <p>{{ successMessage() }}</p>
              </div>
            </div>
          }

          @if (errorMessage()) {
            <div class="form-feedback form-feedback--error"
                role="alert"
                aria-live="assertive">
              <span class="feedback-icon" aria-hidden="true">!</span>

              <div>
                <strong>Envoi impossible</strong>
                <p>{{ errorMessage() }}</p>
              </div>
            </div>
          }

          <div class="form-submit">
            <button
              type="submit"
              class="btn-submit"
              [disabled]="sending()">

              @if (sending()) {
                <span class="button-spinner" aria-hidden="true"></span>
                Envoi en cours…
              } @else {
                {{ 'pages.etudes-bibliques.etudes-bibliques.text027' | translate }}
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
</main>
